// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/wp-" + "a296a88b4e302954e1a9" + ".css";
};